export default {
  'YouTube and High Definition Videos': 'यूट्यूब और हाई डेफिनिशन वीडियो',
  'Story videos (Instagram/Snaps/TikTok)': 'स्टोरी वीडियो (इंस्टाग्राम/स्नैप/टिकटॉक)',
  'Facebook and Instagram Feed videos': 'फेसबुक और इंस्टाग्राम फीड वीडियो',
  'Facebook and Twitter Portrait Videos': 'फेसबुक और ट्विटर पोर्ट्रेट वीडियो',
  'Twitter and Facebbok Landscape Videos': 'ट्विटर और फेसबुक लैंडस्केप वीडियो',
  'Facebook Cover Videos And Blog Banners': 'फेसबुक कवर वीडियो और ब्लॉग बैनर',
  'Fit': 'फिट करें',
  'Fill': 'भरें',
}